import { render } from "./componentAvatar.vue?vue&type=template&id=f7457ea4"
import script from "./componentAvatar.vue?vue&type=script&lang=js"
export * from "./componentAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__